export interface WebDevScores {
  designQuality: number;
  functionality: number;
  performance: number;
}

export interface Question {
  id: number;
  text: string;
  options: {
    text: string;
    scores: WebDevScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    text: "How does your current website perform in terms of conversions?",
    options: [
      {
        text: "No website or very outdated - losing potential customers",
        scores: { designQuality: 3, functionality: 3, performance: 2 },
      },
      {
        text: "Basic website but rarely generates leads or sales",
        scores: { designQuality: 2, functionality: 3, performance: 2 },
      },
      {
        text: "Decent traffic but conversion rates are disappointing",
        scores: { designQuality: 2, functionality: 2, performance: 2 },
      },
      {
        text: "Strong conversion rates with measurable ROI",
        scores: { designQuality: 0, functionality: 1, performance: 1 },
      },
    ],
  },
  {
    id: 2,
    text: "What's your biggest website challenge right now?",
    options: [
      {
        text: "Design looks unprofessional or outdated",
        scores: { designQuality: 3, functionality: 1, performance: 1 },
      },
      {
        text: "Missing key features customers expect",
        scores: { designQuality: 1, functionality: 3, performance: 1 },
      },
      {
        text: "Slow loading times and poor mobile experience",
        scores: { designQuality: 1, functionality: 1, performance: 3 },
      },
      {
        text: "Not showing up in local search results",
        scores: { designQuality: 2, functionality: 2, performance: 2 },
      },
    ],
  },
  {
    id: 3,
    text: "How well does your website work on mobile devices?",
    options: [
      {
        text: "Not mobile-friendly at all or very difficult to use",
        scores: { designQuality: 2, functionality: 2, performance: 3 },
      },
      {
        text: "Works on mobile but not optimized for touch/small screens",
        scores: { designQuality: 2, functionality: 2, performance: 3 },
      },
      {
        text: "Responsive but could be better optimized",
        scores: { designQuality: 1, functionality: 1, performance: 2 },
      },
      {
        text: "Fully optimized mobile-first experience",
        scores: { designQuality: 0, functionality: 1, performance: 1 },
      },
    ],
  },
  {
    id: 4,
    text: "What functionality does your website currently offer?",
    options: [
      {
        text: "Just basic information - no interactive features",
        scores: { designQuality: 1, functionality: 3, performance: 1 },
      },
      {
        text: "Contact forms but nothing else",
        scores: { designQuality: 1, functionality: 3, performance: 1 },
      },
      {
        text: "Some features but missing key capabilities customers need",
        scores: { designQuality: 1, functionality: 2, performance: 2 },
      },
      {
        text: "Full e-commerce, booking, or custom functionality",
        scores: { designQuality: 1, functionality: 0, performance: 1 },
      },
    ],
  },
  {
    id: 5,
    text: "How fast does your website load?",
    options: [
      {
        text: "Very slow - takes several seconds or times out",
        scores: { designQuality: 1, functionality: 1, performance: 3 },
      },
      {
        text: "Noticeably slow - customers probably leave before it loads",
        scores: { designQuality: 1, functionality: 1, performance: 3 },
      },
      {
        text: "Acceptable but could be faster",
        scores: { designQuality: 1, functionality: 1, performance: 2 },
      },
      {
        text: "Lightning fast - loads in under 2 seconds",
        scores: { designQuality: 1, functionality: 1, performance: 0 },
      },
    ],
  },
  {
    id: 6,
    text: "How does your website showcase your Saskatchewan business identity?",
    options: [
      {
        text: "Generic template - doesn't reflect our brand at all",
        scores: { designQuality: 3, functionality: 1, performance: 1 },
      },
      {
        text: "Basic branding but nothing unique or memorable",
        scores: { designQuality: 3, functionality: 1, performance: 1 },
      },
      {
        text: "Good branding but could better highlight local presence",
        scores: { designQuality: 2, functionality: 1, performance: 1 },
      },
      {
        text: "Strongly represents our brand and local community connection",
        scores: { designQuality: 0, functionality: 1, performance: 1 },
      },
    ],
  },
  {
    id: 7,
    text: "How easy is it for you to update your website content?",
    options: [
      {
        text: "Impossible - need to hire someone for any change",
        scores: { designQuality: 1, functionality: 3, performance: 1 },
      },
      {
        text: "Very difficult - requires technical knowledge",
        scores: { designQuality: 1, functionality: 3, performance: 1 },
      },
      {
        text: "Possible but time-consuming and frustrating",
        scores: { designQuality: 1, functionality: 2, performance: 1 },
      },
      {
        text: "Easy content management system - update anytime",
        scores: { designQuality: 1, functionality: 0, performance: 1 },
      },
    ],
  },
];
